import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const GameConsoleIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "GameConsoleIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M10.2541 10.1535H9.59672V9.49622C9.59672 9.17834 9.33894 8.92072 9.02122 8.92072C8.70334 8.92072 8.44572 9.17835 8.44572 9.49622V10.1535H7.78839C7.47051 10.1535 7.21289 10.4112 7.21289 10.729C7.21289 11.0469 7.47052 11.3045 7.78839 11.3045H8.44572V11.9619C8.44572 12.2798 8.70335 12.5374 9.02122 12.5374C9.33895 12.5374 9.59672 12.2797 9.59672 11.9619V11.3045H10.2541C10.5719 11.3045 10.8296 11.0469 10.8296 10.729C10.8296 10.4112 10.5719 10.1535 10.2541 10.1535Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.9938 9.49622C16.9938 9.8141 16.736 10.0717 16.4183 10.0717C16.1004 10.0717 15.8428 9.81409 15.8428 9.49622C15.8428 9.17835 16.1004 8.92072 16.4183 8.92072C16.736 8.92072 16.9938 9.17835 16.9938 9.49622Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.7609 10.7296C15.7609 11.0475 15.5031 11.3051 15.1854 11.3051C14.8675 11.3051 14.6099 11.0475 14.6099 10.7296C14.6099 10.4117 14.8675 10.1541 15.1854 10.1541C15.5031 10.1541 15.7609 10.4117 15.7609 10.7296Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.9938 11.962C16.9938 12.2799 16.736 12.5375 16.4183 12.5375C16.1004 12.5375 15.8428 12.2799 15.8428 11.962C15.8428 11.6443 16.1004 11.3865 16.4183 11.3865C16.736 11.3865 16.9938 11.6443 16.9938 11.962Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.2267 10.7296C18.2267 11.0475 17.9689 11.3051 17.6512 11.3051C17.3333 11.3051 17.0757 11.0475 17.0757 10.7296C17.0757 10.4117 17.3333 10.1541 17.6512 10.1541C17.9689 10.1541 18.2267 10.4117 18.2267 10.7296Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M22.4764 15.1087L21.1596 9.51256C20.7784 7.89186 19.3062 6.4549 17.2997 6.4549H8.14008C6.02406 6.4549 4.63461 8.00501 4.28001 9.51256L2.9634 15.1087C2.60551 16.6298 3.76071 18.0852 5.32116 18.0852C5.98509 18.0852 6.6096 17.7315 6.95085 17.1623L7.96517 15.4719C8.13857 15.1826 8.45585 15.0031 8.79306 15.0031H16.6467C16.9839 15.0031 17.3011 15.1826 17.4746 15.472L18.4886 17.1621C18.8301 17.7315 19.4546 18.0852 20.1192 18.0852C21.6815 18.0852 22.8337 16.6271 22.4764 15.1087ZM20.1185 16.9341C19.8567 16.9341 19.6103 16.7946 19.4755 16.57L18.4615 14.8799C18.0815 14.2459 17.3861 13.8521 16.6468 13.8521H8.79308C8.05377 13.8521 7.35837 14.2459 6.9783 14.8797L5.96398 16.5701C5.8294 16.7946 5.58301 16.9341 5.32044 16.9341C4.5023 16.9341 3.89607 16.1697 4.08371 15.3723L5.40032 9.77618C5.70096 8.49838 6.82754 7.6059 8.1401 7.6059H17.2997C18.6122 7.6059 19.7389 8.49838 20.0394 9.77618L21.3561 15.3723C21.5435 16.1692 20.9384 16.9341 20.1185 16.9341Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default GameConsoleIcon;
